module.exports = __webpack_public_path__ + "img/arrow-left.025c5394.svg";